import {
  useAccountOnHoldDialog,
  usePlanCancelledDialog,
  useUpdateBillingErrorToast,
  useUpdateBillingSuccessToast,
} from "@/features/subscription-management";

export const SubscriptionProvider = ({
  children,
}: { children: React.ReactNode }) => {
  useAccountOnHoldDialog();
  useUpdateBillingErrorToast();
  useUpdateBillingSuccessToast();
  usePlanCancelledDialog();
  return <>{children}</>;
};
